/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const return_1_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5.25 21.747-4.5-4.5m0 0 4.5-4.5m-4.5 4.5h15a7.5 7.5 0 1 0 0-15h-6"
    />
  </svg>
)
export default return_1_medium
